export const NAVIGATION_LINKS = [
  { id: 'hero', label: 'Início' },
  { id: 'services', label: 'Serviços' },
  { id: 'differences', label: 'Diferenciais' },
  { id: 'about', label: 'Sobre' },
] as const;
